module.exports = __webpack_public_path__ + "static/Ccards36-0b1ce1ee8a2e33f6070a83e523bf992d.png";